import { Api } from '../../../config/axiosConfig';
import { ServiceHandler } from '../../../utils/api.utils';
import type {
  KBAssignmentResponse,
  KBDocTypesResponse,
  KBGroup,
  KBRegistryResponse,
  KBTreesResponse,
} from '../types';

export const getKBRegistry = ServiceHandler<unknown, KBRegistryResponse>({
  url: '/api/chat-agent/v1/kb/registry',
});

export function getKBDocumentBlob(url: string) {
  return Api.get<Blob>(url, { responseType: 'blob' });
}

// ── KB browse endpoints ─────────────────────────────────────

export const getKBTrees = ServiceHandler<unknown, KBTreesResponse>({
  url: '/api/chat-agent/v1/kb/products/:productLine/:product/trees',
});

export const getKBDocTypes = ServiceHandler<unknown, KBDocTypesResponse>({
  url: '/api/chat-agent/v1/kb/doc-types',
});

// ── KB Groups ───────────────────────────────────────────────

export const getKBGroups = ServiceHandler<unknown, { groups: KBGroup[] }>({
  url: '/api/chat-agent/v1/kb/groups',
});

// ── Agent KB assignment ─────────────────────────────────────

export const getAgentKnowledge = ServiceHandler<unknown, KBAssignmentResponse>({
  url: '/api/chat-agent/v1/agents/:agentId/knowledge',
});

export const putAgentKnowledge = ServiceHandler<
  Record<string, unknown>,
  KBAssignmentResponse
>({
  url: '/api/chat-agent/v1/agents/:agentId/knowledge',
  method: 'PUT',
});
